import React, { ReactElement } from "react";

import "./style.scss";

interface IStatCardProps {
  title: string;
  value: number;
  icon: ReactElement;
  bgColor: string;
  className?: string;
}
const StatCard: React.FC<IStatCardProps> = ({
  title,
  value,
  icon,
  bgColor,
  className,
}) => {
  return (
    <div
      className={`flex items-center h-28 bg-[#EEF3F8] rounded-xl px-[15px] py-3  ${className || ""}`}
    >
      <div className="stat-card-icon" style={{ backgroundColor: bgColor }}>
        {icon}
      </div>
      <div className="stat-card-text">
        <div className="stat-card-title">{title}</div>
        <div className="stat-card-value">{value}</div>
      </div>
    </div>
  );
};

export default StatCard;
